import { Component, OnInit } from "@angular/core";

import { Observable } from "rxjs";

import { getErrorMessage } from "@dffedb/util";

import { Faktura } from "../model/faktura.model";
import { FakturagodkendelseEventArgs } from "../model/fakturagodkendelse-event.model";
import { FakturagodkendelseViewModel } from "../model/fakturagodkendelse.view-model";
import { FakturagodkendelseSandbox } from "../shared/fakturagodkendelse.sandbox";

@Component({
    selector: "fakturagodkendelse",
    templateUrl: "./fakturagodkendelse.component.html"
})
export class FakturagodkendelseComponent implements OnInit {
    public vm$: Observable<FakturagodkendelseViewModel>;

    constructor(private sandbox: FakturagodkendelseSandbox) {}

    public ngOnInit(): void {
        this.afvis = this.afvis.bind(this);
        this.godkend = this.godkend.bind(this);
        this.hentDokumentUrler = this.hentDokumentUrler.bind(this);
        this.vm$ = this.sandbox.hentFakturaerTilGodkendelse();
    }

    public async hentDokumentUrler(faktura: Faktura): Promise<void> {
        try {
            faktura.dokumentUrler = await this.sandbox.hentDokumentUrler(faktura);
        } catch (error) {
            faktura.pdfLoadError = getErrorMessage(error);
            return Promise.reject(error);
        }
    }

    public godkend(args: FakturagodkendelseEventArgs): Promise<void> {
        return this.sandbox.godkendFaktura(args.faktura, args.kodeord, args.bemaerkning);
    }

    public afvis(args: FakturagodkendelseEventArgs): Promise<void> {
        return this.sandbox.afvisFaktura(args.status, args.faktura, args.kodeord, args.bemaerkning);
    }
}
